/* Markeking — carrito lateral emergente */
(function () {
  'use strict';
  if (customElements.get('mk-cart-drawer')) return;

  var money = function (c) { return window.mkMoney ? window.mkMoney(c) : (c / 100).toFixed(2); };
  var s = function (k) { return (window.mkTheme && window.mkTheme.strings[k]) || ''; };
  var esc = function (v) { var d = document.createElement('div'); d.textContent = v == null ? '' : String(v); return d.innerHTML; };
  var abs = function (url) { return url && url.indexOf('//') === 0 ? 'https:' + url : url; };
  var sized = function (url, w) { url = abs(url); if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  var root = function () { return ((window.mkTheme && window.mkTheme.routes.root_url) || '/').replace(/\/?$/, '/'); };

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime()), n = 0;
    while (n < days) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n++; }
    return d;
  }

  class MkCartDrawer extends HTMLElement {
    connectedCallback() {
      this.items = this.querySelector('[data-mk-drawer-items]');
      this.empty = this.querySelector('[data-mk-drawer-empty]');
      this.foot = this.querySelector('[data-mk-drawer-foot]');
      this.upsellBox = this.querySelector('[data-mk-drawer-upsell]');
      this.recsBox = this.querySelector('[data-mk-drawer-recs]');
      this.guarantee = this.querySelector('[data-mk-drawer-guarantee]');
      this.busy = false;

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-mk-drawer-close]')) { this.close(); return; }
        var btn = e.target.closest('[data-mk-qty-change]');
        if (btn) { this.change(btn.dataset.key, Number(btn.dataset.qty)); return; }
        var add = e.target.closest('[data-mk-quick-add]');
        if (add) { this.quickAdd(Number(add.dataset.id), add); }
      });
      var codeForm = this.querySelector('[data-mk-drawer-code]');
      if (codeForm) codeForm.addEventListener('submit', (e) => { e.preventDefault(); this.applyCode(codeForm.code.value.trim()); });

      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      document.addEventListener('mk:cart:added', () => this.open());
      document.addEventListener('click', (e) => {
        var link = e.target.closest('[data-mk-cart-open]');
        if (!link) return;
        e.preventDefault();
        this.open();
      });

      this.initTimer();
      this.initDelivery();
    }

    open() {
      this.render().then(() => {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('mk-no-scroll');
        var close = this.querySelector('.mk-drawer-cart__head [data-mk-drawer-close]');
        if (close) close.focus({ preventScroll: true });
      });
    }

    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mk-no-scroll');
    }

    fetchCart() {
      return fetch(window.mkTheme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    render(cartData) {
      var p = cartData ? Promise.resolve(cartData) : this.fetchCart();
      return p.then((cart) => {
        this.cart = cart;
        var has = cart.item_count > 0;
        document.querySelectorAll('[data-mk-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !has;
        });
        this.querySelector('[data-mk-drawer-count]').textContent = has ? '(' + cart.item_count + ')' : '';
        this.empty.hidden = has;
        this.foot.hidden = !has;
        if (this.guarantee) this.guarantee.hidden = !has;
        this.items.innerHTML = cart.items.map((item) => this.itemHTML(item)).join('');

        var original = cart.items.reduce(function (sum, i) {
          var unitWas = Math.max(i.original_price, (i.compare_at_price || 0));
          return sum + unitWas * i.quantity;
        }, 0);
        var saved = original - cart.total_price;
        var was = this.querySelector('[data-mk-drawer-was]');
        was.hidden = !(saved > 0);
        was.textContent = money(original);
        this.querySelector('[data-mk-drawer-subtotal]').textContent = money(cart.total_price);
        var savedEl = this.querySelector('[data-mk-drawer-saved]');
        savedEl.hidden = !(saved > 0);
        savedEl.textContent = '− ' + money(saved);

        this.renderProgress(cart);
        return Promise.all([this.renderRecs(cart), this.renderUpsell(cart)]);
      });
    }

    itemHTML(item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span class="mk-drawer-item__variant">' + esc(item.variant_title) + '</span>' : '';
      var unitWas = Math.max(item.original_price, item.compare_at_price || 0) * item.quantity;
      var was = unitWas > item.final_line_price ? '<s>' + money(unitWas) + '</s>' : '';
      var discounts = (item.line_level_discount_allocations || []).map(function (d) {
        return '<span class="mk-drawer-item__discount">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</span>';
      }).join('');
      return '' +
        '<li class="mk-drawer-item">' +
          '<a class="mk-drawer-item__img" href="' + esc(item.url) + '">' + (item.image ? '<img src="' + esc(sized(item.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="mk-drawer-item__info">' +
            '<a class="mk-drawer-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            variant + discounts +
            '<div class="mk-drawer-item__row">' +
              '<div class="mk-drawer-qty">' +
                '<button type="button" data-mk-qty-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="-">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-mk-qty-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="+">+</button>' +
              '</div>' +
              '<div class="mk-drawer-item__price"><strong>' + money(item.final_line_price) + '</strong>' + was + '</div>' +
            '</div>' +
            '<button type="button" class="mk-drawer-item__remove" data-mk-qty-change data-key="' + esc(item.key) + '" data-qty="0">' + esc(s('remove')) + '</button>' +
          '</div>' +
        '</li>';
    }

    /* Barra de progreso: por importe o por número de artículos */
    renderProgress(cart) {
      var box = this.querySelector('[data-mk-drawer-progress]');
      var goal = Number(this.dataset.goal) || 0;
      if (!goal || !cart.item_count) { box.hidden = true; return; }
      box.hidden = false;
      var byQty = this.dataset.goalMode === 'quantity';
      var current = byQty ? cart.item_count : cart.total_price;
      // Niveles por cantidad, p. ej. "2:10,3:15,4:25" (artículos:porcentaje)
      var tiers = (this.dataset.goalTiers || '').split(',').map(function (t) {
        var p = t.split(':');
        return { qty: Number(p[0]), pct: Number(p[1]) };
      }).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
      var nextTier = null, reached = null;
      if (byQty && tiers.length) {
        tiers.forEach(function (t) { if (current >= t.qty) reached = t; else if (!nextTier) nextTier = t; });
        goal = tiers[tiers.length - 1].qty;
      }
      var left = nextTier ? nextTier.qty - current : goal - current;
      var pct = Math.min(100, Math.round(current * 100 / goal));
      var text;
      if (left > 0) {
        text = esc(this.dataset.goalText)
          .replace('[amount]', '<strong>' + money(left) + '</strong>')
          .replace('[count]', '<strong>' + left + '</strong>')
          .replace('[discount]', '<strong>' + (nextTier ? nextTier.pct : '') + '</strong>');
        if (reached && this.dataset.goalCurrent) {
          text = esc(this.dataset.goalCurrent).replace('[discount]', '<strong>' + reached.pct + '</strong>') + '<br>' + text;
        }
      } else {
        text = esc(this.dataset.goalDone).replace('[discount]', '<strong>' + (reached ? reached.pct : '') + '</strong>');
      }
      this.querySelector('[data-mk-drawer-progress-text]').innerHTML = text;
      this.querySelector('[data-mk-drawer-bar]').style.width = pct + '%';
      box.classList.toggle('is-done', left <= 0);
    }

    /* Recomendaciones de Shopify según lo que hay en el carrito */
    renderRecs(cart) {
      var limit = Number(this.dataset.recs) || 0;
      if (!limit || !cart.item_count) { this.recsBox.hidden = true; return Promise.resolve(); }
      var base = cart.items[0].product_id;
      var load = this.recsCache && this.recsCache.base === base ? Promise.resolve(this.recsCache.products)
        : fetch(root() + 'recommendations/products.json?product_id=' + base + '&limit=8&intent=related')
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then((data) => { this.recsCache = { base: base, products: data.products || [] }; return this.recsCache.products; })
            .catch(function () { return []; });
      return load.then((products) => {
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var list = products.filter(function (p) {
          return inCart.indexOf(p.id) === -1 && (p.variants || []).some(function (v) { return v.available; });
        }).slice(0, limit);
        if (!list.length) { this.recsBox.hidden = true; return; }
        var cards = list.map((p) => {
          var v = p.variants.find(function (x) { return x.available; });
          var img = p.featured_image ? sized(p.featured_image, 300) : '';
          var was = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '';
          var select = p.variants.length > 1 && !(p.variants.length === 1 && v.title === 'Default Title')
            ? '<select class="mk-drawer-rec__select" data-mk-rec-variant>' + p.variants.map(function (x) {
                return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + (x.id === v.id ? ' selected' : '') + '>' + esc(x.title) + '</option>';
              }).join('') + '</select>'
            : '';
          return '' +
            '<div class="mk-drawer-rec">' +
              '<a class="mk-drawer-rec__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
              '<a class="mk-drawer-rec__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<span class="mk-drawer-rec__price"><strong>' + money(v.price) + '</strong>' + was + '</span>' +
              select +
              '<button type="button" class="mk-btn mk-btn--primary mk-drawer-rec__btn" data-mk-quick-add data-id="' + v.id + '">' + esc(this.dataset.recsButton || '+') + '</button>' +
            '</div>';
        }).join('');
        var arrow = function (dir) {
          var d = dir === 'prev' ? 'm15 6-6 6 6 6' : 'm9 6 6 6-6 6';
          return '<button type="button" class="mk-drawer-recs__arrow mk-drawer-recs__arrow--' + dir + '" data-mk-recs-' + dir + ' aria-label="' + (dir === 'prev' ? '‹' : '›') + '">' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg></button>';
        };
        this.recsBox.innerHTML = '' +
          (this.dataset.recsTitle ? '<p class="mk-drawer-recs__title">' + esc(this.dataset.recsTitle) + '</p>' : '') +
          (this.dataset.recsNote ? '<p class="mk-drawer-recs__note">' + esc(this.dataset.recsNote) + '</p>' : '') +
          '<div class="mk-drawer-recs__wrap">' + arrow('prev') +
            '<div class="mk-drawer-recs__track" data-mk-recs-track>' + cards + '</div>' +
          arrow('next') + '</div>';
        this.recsBox.querySelectorAll('[data-mk-rec-variant]').forEach(function (sel) {
          sel.addEventListener('change', function () {
            sel.closest('.mk-drawer-rec').querySelector('[data-mk-quick-add]').dataset.id = sel.value;
          });
        });
        this.recsBox.hidden = false;
        this.initRecsSlider();
      });
    }

    /* Carrusel de recomendaciones: flechas, avance automático y arrastre con ratón */
    initRecsSlider() {
      var track = this.recsBox.querySelector('[data-mk-recs-track]');
      var prev = this.recsBox.querySelector('[data-mk-recs-prev]');
      var next = this.recsBox.querySelector('[data-mk-recs-next]');
      if (!track) return;
      clearInterval(this._recsTimer);

      var step = function () {
        var card = track.querySelector('.mk-drawer-rec');
        return card ? card.getBoundingClientRect().width + 10 : 160;
      };
      var atEnd = function () { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; };
      var update = function () {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        prev.hidden = next.hidden = !overflow;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = atEnd();
      };
      var go = function (dir) {
        if (dir > 0 && atEnd()) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });

      var paused = false;
      ['mouseenter', 'touchstart', 'focusin'].forEach(function (ev) {
        track.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      track.addEventListener('mouseleave', function () { paused = false; });
      this._recsTimer = setInterval(() => {
        if (paused || document.hidden || !this.classList.contains('is-open')) return;
        if (track.scrollWidth <= track.clientWidth + 4) return;
        go(1);
      }, 3500);

      var dragging = false, moved = false, startX = 0, startLeft = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.target.closest('button, select')) return;
        dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = startLeft - dx;
      });
      var stop = function () {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', stop);
      track.addEventListener('pointerleave', stop);
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      update();
    }

    /* Producto sugerido fijo, elegido en el editor */
    renderUpsell(cart) {
      var handle = this.dataset.upsell;
      if (!handle || !cart.item_count) { this.upsellBox.hidden = true; return Promise.resolve(); }
      var load = this.upsellProduct ? Promise.resolve(this.upsellProduct)
        : fetch(root() + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; });
      return load.then((p) => {
        this.upsellProduct = p;
        if (!p) { this.upsellBox.hidden = true; return; }
        var inCart = cart.items.some(function (i) { return i.product_id === p.id; });
        var v = (p.variants || []).find(function (x) { return x.available; });
        if (inCart || !v) { this.upsellBox.hidden = true; return; }
        var img = p.featured_image ? sized(p.featured_image, 160) : '';
        var was = v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '';
        this.upsellBox.innerHTML = '' +
          (this.dataset.upsellTitle ? '<p class="mk-drawer-upsell__title">' + esc(this.dataset.upsellTitle) + '</p>' : '') +
          '<div class="mk-drawer-upsell">' +
            (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
            '<div class="mk-drawer-upsell__info"><span class="mk-drawer-upsell__name">' + esc(p.title) + '</span>' +
            '<span class="mk-drawer-upsell__price"><strong>' + money(v.price) + '</strong>' + was + '</span></div>' +
            '<button type="button" class="mk-btn mk-btn--primary mk-drawer-upsell__btn" data-mk-quick-add data-id="' + v.id + '">' + esc(this.dataset.upsellLabel || '+') + '</button>' +
          '</div>';
        this.upsellBox.hidden = false;
      });
    }

    change(key, qty) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      fetch(window.mkTheme.routes.cart_url + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      })
        .then(function (r) { return r.json(); })
        .then((cart) => this.render(cart))
        .finally(() => { this.busy = false; this.classList.remove('is-busy'); });
    }

    quickAdd(id, btn) {
      btn.disabled = true;
      fetch(window.mkTheme.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(() => this.render())
        .finally(function () { btn.disabled = false; });
    }

    /* Código de descuento: Shopify lo guarda y lo aplica al pagar */
    applyCode(code) {
      if (!code) return;
      var msg = this.querySelector('[data-mk-drawer-code-msg]');
      var checkout = this.querySelector('[data-mk-drawer-checkout]');
      fetch(root() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {})
        .then(() => {
          checkout.href = window.mkTheme.routes.cart_url + '/checkout?discount=' + encodeURIComponent(code);
          msg.textContent = (this.dataset.codeApplied || '[code]').replace('[code]', code);
          msg.hidden = false;
        });
    }

    /* Temporizador de una oferta real con fecha de fin */
    initTimer() {
      var raw = (this.dataset.timer || '').trim();
      var box = this.querySelector('[data-mk-drawer-timer]');
      if (!raw || !box) return;
      var end = new Date(raw.replace(' ', 'T'));
      if (isNaN(end.getTime())) return;
      var text = box.querySelector('[data-mk-drawer-timer-text]');
      var tpl = this.dataset.timerText || '[timer]';
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = () => {
        var ms = end.getTime() - Date.now();
        if (ms <= 0) { box.hidden = true; clearInterval(this._timer); return; }
        var sec = Math.floor(ms / 1000);
        var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60), ss = sec % 60;
        var t = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(ss);
        text.innerHTML = esc(tpl).replace('[timer]', '<strong>' + t + '</strong>');
        box.hidden = false;
      };
      tick();
      this._timer = setInterval(tick, 1000);
    }

    /* Fecha de entrega estimada */
    initDelivery() {
      var raw = (this.dataset.delivery || '').split(',');
      var box = this.querySelector('[data-mk-drawer-delivery]');
      if (raw.length < 2 || !box) return;
      var locale = (window.mkTheme && window.mkTheme.locale) || 'en';
      var fmt;
      try { fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' }); }
      catch (e) { fmt = new Intl.DateTimeFormat('en', { weekday: 'short', day: 'numeric', month: 'short' }); }
      var now = new Date();
      var start = fmt.format(addBusinessDays(now, Number(raw[0]) || 0));
      var end = fmt.format(addBusinessDays(now, Number(raw[1]) || 0));
      box.querySelector('[data-mk-drawer-delivery-text]').innerHTML = esc(this.dataset.deliveryText || '')
        .replace('[start]', '<strong>' + esc(start) + '</strong>')
        .replace('[end]', '<strong>' + esc(end) + '</strong>');
      box.hidden = false;
    }
  }

  customElements.define('mk-cart-drawer', MkCartDrawer);
})();
